import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Divider, Popconfirm, Badge, Tooltip } from 'antd';

const trainStatusMap = {
  todo: '待学习',
  done: '已学习',
  unable: '无法学习',
};
export default (self, s) => [
  {
    title: '问题',
    dataIndex: 'questions',
    key: 'questions',
    render: t => <div>{t[0] && t[0].title}</div>,
    width: 300,
  },
  {
    title: '知识点',
    dataIndex: 'knowledge_title',
    key: 'knowledge_title',
    width: 100,
  },
  {
    title: '知识点分类',
    dataIndex: 'knowledge_category_title',
    key: 'knowledge_category_title',
    width: 100,
  },
  {
    title: '组织机构',
    dataIndex: 'organization_name',
    key: 'organization_name',
    width: 100,
  },
  {
    title: '有效期',
    dataIndex: 'timeout',
    key: 'timeout',
    width: 100,
    render: t => moment(t).format('YYYY-MM-DD'),
  },
  {
    title: '赞',
    dataIndex: 'up',
    width: 30,
    key: 'up',
    sorter: true,
  },
  {
    title: '踩',
    dataIndex: 'down',
    width: 30,
    key: 'down',
    sorter: true,
  },
  {
    title: '问',
    dataIndex: 'ask_times',
    width: 30,
    key: 'ask_times',
    sorter: true,
  },
  {
    title: '位置',
    dataIndex: 'hot_place',
    width: 80,
    key: 'hot_place',
    sorter: true,
    render: t => {
      if (t) {
        return t === 'left_top' ? '左' : '右';
      }
      return '';
    },
  },
  {
    title: '排序',
    dataIndex: 'hot_index',
    width: 80,
    key: 'hot_index',
    sorter: true,
  },
  {
    title: '学习',
    dataIndex: 'train_status',
    width: 80,
    key: 'train_status',
    render: t => (
      <Tooltip
        title={
          t === 'unable' ? (
            <div>
              相似问题少于 1 个，无法学习。
              <br />
              请添加相似问题。
            </div>
          ) : (
            ''
          )
        }
        placement="top"
      >
        <span
          className={cn({
            [s.danger]: t === 'unable',
            [s.success]: t === 'done',
          })}
        >
          {trainStatusMap[t]}
        </span>
      </Tooltip>
    ),
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 60,
    key: 'status',
    render: t => (
      <div className={s.statusBadge}>
        <Badge
          status={t === 'on' ? 'processing' : 'default'}
          text={t === 'on' ? '启用' : '停用'}
        />
      </div>
    ),
  },
  {
    title: '操作',
    dataIndex: 'x',
    key: 'x',
    width: 240,
    render: (t, item) => (
      <div>
        <a onClick={() => self.showAnswer(item.content)}>查看答案</a>
        <Divider type="vertical" />
        <a onClick={() => self.showSameQuestions(item)}>相似问题</a>
        <Divider type="vertical" />
        <a
          onClick={() => {
            self.setModals({
              key: 'updateForm',
              title: '编辑问题',
              item,
              visible: true,
            });
          }}
        >
          编辑
        </a>
        <Divider type="vertical" />
        <Popconfirm
          title={`确认${item.status === 'on' ? '停用？' : '启用？'}`}
          placement="left"
          okText="确认"
          cancelText="取消"
          onConfirm={() => self.triggerStatus(item.id, item.status)}
        >
          <a>{item.status === 'on' ? '停用' : '启用'}</a>
        </Popconfirm>{' '}
        {item.status === 'off' && [
          <Divider type="vertical" key="1" />,
          <Popconfirm
            title="确认删除？"
            placement="left"
            okText="确认"
            cancelText="取消"
            onConfirm={() => self.deleteItem(item.id)}
          >
            <a>删除</a>
          </Popconfirm>,
        ]}
      </div>
    ),
  },
];
